import { get, post, put } from '../lib/apiClient';

export const getUsage = () => get('/billing/usage');
export const listTiers = () => get('/billing/tiers');
export const listAddOns = () => get('/billing/addons');

export const updateTier = (tierId, data) =>
  put(`/billing/tiers/${encodeURIComponent(tierId)}`, data);

export const createCheckout = (tierId, successUrl, cancelUrl) =>
  post('/billing/checkout', { tierId, successUrl, cancelUrl });

export const createPortalSession = returnUrl =>
  post('/billing/portal', { returnUrl });

/**
 * Billing notification choices of the signed-in org admin or owner
 * (docs/Decisions.md D59). Resolve to `{ categories, subscribed }`.
 */
export const getBillingSubscriptions = () => get('/billing/notifications/subscriptions');
export const updateBillingSubscriptions = categories =>
  put('/billing/notifications/subscriptions', { categories });

/**
 * Stop every recurring donation of an org that is no longer a nonprofit
 * (docs/Decisions.md D65 item 5). Resolves to `{ found, halted }`.
 */
export const haltRecurringDonations = orgId => post('/billing/donations/recurring/halt', { orgId });
